import React from 'react'
import StepBox from '../components/StepBox'
import { IoPeople } from "react-icons/io5";
import { IoRocket } from "react-icons/io5";
import { FaPenNib } from "react-icons/fa";

const Steps = () => {
    return (
        <div className='p-4 py-20 specialBg'>

            <h1 data-aos="fade-down"
                data-aos-easing="ease-in-out" dir='rtl' className="font-bold  text-3xl md:text-5xl text-center gold-text " >

                איך זה עובד?
            </h1>
            <h2 data-aos="fade-in"
                data-aos-easing="ease-in-out" dir='rtl' className=" font-medium px-4 my-2 text-xl md:text-3xl max-w-[1000px] mx-auto text-center text-mainColor ">
                תהליך העבודה איתנו מאוד ידידותי ומורכב מ 3 שלבים פשוטים
            </h2>
            {/* 
            <h2 dir='rtl' className=" font-bold px-4 mt-8 text-lg md:text-xl max-w-[1000px] mx-auto text-center text-shineColor2 ">
                השירותים שלי            </h2> */}

            <div className="flex flex-col justify-center items-center mt-8 p-4 mx-8 ">
                <div data-aos="fade-down"
                    data-aos-easing="ease-in-out">


                    <StepBox
                        header="שיחת יעוץ והבנת צרכי הלקוח
                    "
                        text="בה נכיר אתכם ואתם אותנו,
                    אבין אם אנחנו מתאימים,
                    נציג לכם את התוכנית הראשונית שמתאימה עבורכם ונצא לדרך משותפת."
                        icon={IoPeople}
                        number={1}
                    />
                </div>

                <div data-aos="fade-down"
                    data-aos-easing="ease-in-out">
                    <StepBox
                        header=" עיצוב הקמה ואפיון

                    "
                        text="עיצוב סקיצות לפי צרכי הלקוח, זמן ההכנה יכול לקחת עד כמה ימי עסקים, נבצע עיצובים על פי מה שתיאמנו ולאחר מכן תהיה אופציה לתיקונים."
                        icon={FaPenNib}
                        number={2}
                    />
                </div>
                <div data-aos="fade-down"
                    data-aos-easing="ease-in-out">
                    <StepBox
                        header="אישור ושליחה


                    "
                        text="לאחר שנציג בפניכם את כל החומר, נחכה לאישור מכם, נבצע תיקונים במידת הצורך ולאחר מכן הכל יישלח אליכם בצורה מסודרת."
                        icon={IoRocket}
                        number={3}
                    />
                </div>
            </div>


        </div>
    )
}

export default Steps